const Brands = {
  public: 'public',
  koodo: 'koodo'
}

export default Brands
